const FORM_TYPES = {
  GET_IN_TOUCH: 'getInTouch',
  SUBSCRIPTION: 'subscription',
};

export default FORM_TYPES;
